<template>
  <base-dialog class="history-dialog" width="740px" :visible.sync="visible">
    <template v-slot:header>查看历史版本</template>
    <div class="main">
      <el-input
        class="history-search"
        v-model="searchText"
        size="small"
        clearable
        placeholder="请输入版本号"
        prefix-icon="el-icon-search"
        @input="searchHistory"
      ></el-input>
      <base-table
        class="history-table"
        table-height="100%"
        :showPagination="false"
        :table-data="filterHistoryData"
        tooltip-effect="dark"
      >
        <el-table-column
          v-for="column in templateHistoryColumns"
          :key="column.value"
          :prop="column.value"
          :label="column.label"
          :min-width="column.width"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="column.value === 'published'">
              <el-tag v-if="scope.row.published" effect="dark" size="mini">已发布</el-tag>
            </template>
            <template v-else>
              <div>{{ _.get(scope.row, column.value) }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template v-slot="scope">
            <el-button
              :disabled="scope.row.version == useVersion"
              @click.stop="backTo(scope.row)"
              type="text"
            >
              恢复此版本
            </el-button>
          </template>
        </el-table-column>
      </base-table>
    </div>
  </base-dialog>
</template>

<script>
import * as appApi from "@/api/userCenter/app"
import { templateHistoryColumns } from "../static"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseTable from "@/components/BaseComponents/Table"
export default {
  name: "history-dialog",
  components: { BaseTable, BaseDialog },
  data() {
    return {
      templateHistoryColumns,
      visible: false,
      searchText: "",
      filterHistoryData: [],
      historyData: [],
      useVersion: ""
    }
  },
  methods: {
    init(app) {
      this.useVersion = app.templateInfo.version
      appApi.getAppTemplateVersionList(app.id).then(res => {
        this.filterHistoryData = res
        this.historyData = res
        this.visible = true
      })
    },
    searchHistory() {
      this.filterHistoryData = this.historyData.filter(i => i.version.includes(this.searchText))
    },
    backTo(row) {
      appApi.switchAppTemplateVersion(row.templateId, row.version).then(res => {
        this.$emit("refresh")
        this.visible = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.history-dialog {
  .main {
    display: grid;
    .history-search {
      width: 200px;
      margin-left: auto;
      margin-top: -10px;
    }
    .history-table {
      margin-top: 10px;
    }
  }
}
</style>
